import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/mp3/oral_sample.mp3';
const _hoisted_1 = {
  id: "oralTest"
};
const _hoisted_2 = {
  class: "oral-content"
};
const _hoisted_3 = {
  class: "content-item"
};
const _hoisted_4 = {
  class: "step-icon"
};
const _hoisted_5 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "60px",
    "height": "60px"
  }
};
const _hoisted_6 = {
  class: "content-item"
};
const _hoisted_7 = {
  class: "recorder-microphone"
};
const _hoisted_8 = {
  class: "icon microphone-icon",
  style: {
    "width": "60px",
    "height": "60px"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_10 = {
  class: "content-item"
};
const _hoisted_11 = {
  class: "step-icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_Recorder = _resolveComponent("Recorder");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[25] || (_cache[25] = _createElementVNode("head", null, [_createElementVNode("div", null, "设备测试")], -1)), _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("p", {
    class: "step-title"
  }, " 第一步：请戴上耳机，点击播放按钮,播放音频。如音量大小不合适，请调节设备音量。 ", -1)), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
    class: "icon pause-icon",
    style: {
      "width": "60px",
      "height": "60px"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.playTest && $setup.playTest(...args))
  }, null, 512), [[_vShow, $setup.audioStatus == 'yet']])]), _cache[7] || (_cache[7] = _createElementVNode("p", null, "1. 点击播放键可再次收听。", -1)), _cache[8] || (_cache[8] = _createElementVNode("p", null, "2. 若音质不清，请及时更换耳机设备。", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", null, "3. 正式考试中，音频将由系统自动播放。", -1)), _cache[10] || (_cache[10] = _createElementVNode("p", null, "4. 建议使用Chrome、火狐浏览器进行口语考试。", -1))], 512), [[_vShow, $setup.step == 0]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_cache[13] || (_cache[13] = _createElementVNode("p", {
    class: "step-title"
  }, " 第二步：试音环节，点击开始试音后会进入3秒倒计时，倒计时结束并听到“叮”的提示声后，请你用正常音量朗读“Keep on going and never give up.”，听到第二次“叮”声响表示录音结束。 ", -1)), _cache[14] || (_cache[14] = _createElementVNode("p", null, "注：", -1)), _cache[15] || (_cache[15] = _createElementVNode("p", null, " 1.考试期间请勿触碰麦克风，并且将话筒离略低于嘴巴，且距离嘴巴3-5cm。 ", -1)), _cache[16] || (_cache[16] = _createElementVNode("p", null, "2. 如果您的移动设备不能正常录音，请尝试更换设备。", -1)), _cache[17] || (_cache[17] = _createElementVNode("p", null, "3. 录音过程中，可以点击录音键提前结束录音。", -1)), _cache[18] || (_cache[18] = _createElementVNode("p", null, " 4. 考试中，当您完成录音后，点击next按钮将进入下一题。请不要在考试过程中更换设备。 ", -1)), _createElementVNode("div", _hoisted_7, [_withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    icon: $setup.Microphone,
    onClick: $setup.startRecorder
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("开始试音", -1)]))]),
    _: 1
  }, 8, ["icon", "onClick"]), [[_vShow, $setup.recorderStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [[_vShow, $setup.recorderStatus == 'over']]), _withDirectives(_createElementVNode("div", {
    class: "icon-loading",
    style: _normalizeStyle({
      color: $setup.countDown <= 3 ? '#f56c6c' : '#333'
    })
  }, _toDisplayString($setup.countDown), 5), [[_vShow, $setup.recorderStatus == 'loading']]), _withDirectives(_createVNode(_component_el_progress, {
    type: "circle",
    width: "63",
    "stroke-width": "2",
    color: "#4bbbff",
    onClick: $setup.stopRecorder,
    percentage: parseInt(($setup.allTime - $setup.countDown) / $setup.allTime * 100)
  }, {
    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("div", {
      class: "icon microphone-working-icon",
      style: {
        "width": "59px",
        "height": "59px"
      }
    }, null, -1)]))]),
    _: 1
  }, 8, ["onClick", "percentage"]), [[_vShow, $setup.recorderStatus == 'ing']]), _createElementVNode("p", _hoisted_9, _toDisplayString($setup.recorderText), 1)])], 512), [[_vShow, $setup.step == 1]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_cache[19] || (_cache[19] = _createElementVNode("p", {
    class: "step-title"
  }, "第三步：点击播放键，收听你的声音。", -1)), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", {
    class: "icon play-icon loading-ani",
    style: {
      "width": "60px",
      "height": "60px"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
  }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
    class: "icon pause-icon",
    style: {
      "width": "60px",
      "height": "60px"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.playRecorder && $setup.playRecorder(...args))
  }, null, 512), [[_vShow, $setup.audioStatus == 'yet']])]), _cache[20] || (_cache[20] = _createElementVNode("div", null, [_createElementVNode("p", {
    style: {
      "color": "red"
    }
  }, " 为了保证您的录音效果，请关闭当前浏览器除测试外的其它标签页以及请关闭除考试外的其它应用程序 ")], -1))], 512), [[_vShow, $setup.step == 2]]), _createElementVNode("footer", null, [_withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.changeStep
  }, {
    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("NEXT", -1)]))]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $setup.step == 0]]), _withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    style: {
      "margin-right": "10px"
    },
    onClick: $setup.goExam
  }, {
    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("开始考试", -1)]))]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $setup.step == 2]]), _withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    plain: "",
    onClick: _cache[3] || (_cache[3] = $event => $setup.changeStep(0))
  }, {
    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("重新调试", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.step == 2]])])]), _createElementVNode("audio", {
    style: {
      "display": "none"
    },
    preload: "none",
    id: "test_audio",
    onEnded: _cache[4] || (_cache[4] = $event => $setup.audioStatus = 'yet')
  }, [...(_cache[24] || (_cache[24] = [_createElementVNode("source", {
    src: _imports_0,
    type: "audio/mpeg"
  }, null, -1)]))], 32), _createVNode(_component_Recorder, {
    record_switch: $setup.record_switch,
    replay_switch: $setup.replay_switch,
    stop_switch: $setup.stop_switch,
    onStopReplay: _cache[5] || (_cache[5] = $event => $setup.audioStatus = 'yet'),
    record_time: 3 * 1000,
    onSetScores: $setup.setScores,
    refText: "keep on going and never give up",
    onRecording: $setup.recording,
    coreType: $setup.store.state.eval.CORE_TYPE_SENT,
    onRecorderDefeat: $setup.recorderDefeat
  }, null, 8, ["record_switch", "replay_switch", "stop_switch", "onSetScores", "onRecording", "coreType", "onRecorderDefeat"])]);
}